import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { startGaugingUp, uploadWallpapers } from "../../actions/wallpapers";
import { switchBackground } from '../../actions/project/background'
import { removeWallpaper, selectWallpaper } from '../../actions/wallpapers'
import { startCropping } from '../../actions/project/crop'
import WallpapersCollection from '../../components/CollectionWallpapers'
import { assignIndex } from '../../utils'
import { assignSelection, isGauged, removeSystem } from './utilities'

const mapStateToProps = (state, ownState) => ({
  photos: dotProp
    .get(state, 'wallpapers.images', [])
    .map(assignIndex)
    .filter(removeSystem(ownState.onlySystem))
    .map(assignSelection(state))
    .map(isGauged),
  isLoading: dotProp.get(state, 'wallpapers.isLoading', false),
  errMessage: dotProp.get(state, 'wallpapers.errMessage', ''),
  aspect: dotProp.get(state, 'project.background.crop.aspect', false),
  croped: dotProp.get(state, 'project.background.croped', false),
  calibrated: dotProp.get(state, 'project.background.calibrated', true)
})

const mapDispatchToProps = dispatch => ({
  action: {
    active: index => dispatch(selectWallpaper(index)),
    select: (photo, index) => dispatch(switchBackground(photo, index, window.fetch)),
    remove: index => dispatch(removeWallpaper(index)),
    crop: cropType => dispatch(startCropping(cropType)),
    calibrate: () => dispatch(startGaugingUp())
  },
  onDrop: (a, r) => dispatch(uploadWallpapers(a, r)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WallpapersCollection)



// WEBPACK FOOTER //
// ./src/containers/CollectionWallpapers/index.js